import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

const SiteNav = (props) => {
  const { links, windowWidth } = props;
  const isMobile = windowWidth < 760; // abstract this to an external helper function at some point.
  const hideNav = isMobile && !props.toggleMenuOpen;

  const toggleMenu = () => {
    props.toggleMenu(!props.toggleMenuOpen);
  };

  return (
    <div className="site-nav">
      {isMobile && (
        <button
          className={`site-nav-mobile-menu-toggle ${props.toggleMenuOpen ? '--is-active' : ''}`}
          onClick={e => toggleMenu(e)}
        >
          Menu
        </button>
      )}
      {!hideNav && (
        <ul className="site-nav-ul">
          {links.map(item => (
            <li className="site-nav-li" key={item.slug}>
              <Link exact to={item.slug + location.search} className="site-nav-link" activeClassName="--is-active">
                {item.shortTitle}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

SiteNav.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    langKey: PropTypes.string,
    shortTitle: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
  })).isRequired,
  windowWidth: PropTypes.number.isRequired,
  toggleMenu: PropTypes.func.isRequired,
  toggleMenuOpen: PropTypes.bool.isRequired,
};

export default SiteNav;



// WEBPACK FOOTER //
// ./src/components/SiteNav/SiteNav.js